import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const PrivacyPage = () => {
  return (
    <>
      <SEO title="Privacy Policy" description="How TopInfo Rwanda collects, uses, and protects your personal information. Read our privacy policy for data protection details." keywords="privacy policy TopInfo Rwanda, data protection Rwanda, personal information policy" />
      <div className="min-h-screen bg-gray-50/50">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
          <p className="text-sm text-gray-400 mb-8">Last updated: January 2025</p>

          <div className="bg-white rounded-2xl border border-gray-100 p-6 sm:p-8 space-y-6 text-gray-600 text-sm leading-relaxed">
            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">1. Information We Collect</h2>
              <p className="mb-2">We collect the following types of information:</p>
              <ul className="list-disc pl-5 space-y-1">
                <li><strong>Account Information:</strong> Name, email address, phone number, and password when you register.</li>
                <li><strong>Listing Data:</strong> Photos, descriptions, prices, and location data for services and products you post.</li>
                <li><strong>Usage Data:</strong> Pages visited, search queries, and interaction patterns to improve our service.</li>
                <li><strong>Location Data:</strong> When you use the "Detect my location" feature, we access your device's GPS with your permission.</li>
                <li><strong>Messages:</strong> Communications sent through our messaging system.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">2. How We Use Your Information</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>To provide and maintain our marketplace platform.</li>
                <li>To process bookings and orders between users.</li>
                <li>To send notifications about your account activity.</li>
                <li>To improve our services and user experience.</li>
                <li>To prevent fraud and ensure platform security.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">3. Information Sharing</h2>
              <p>We do not sell your personal information. We may share limited information:</p>
              <ul className="list-disc pl-5 space-y-1 mt-2">
                <li>With other users as necessary for transactions (e.g., your name and phone number when you book a service).</li>
                <li>With law enforcement when required by law.</li>
                <li>In aggregated, anonymized form for analytics purposes.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">4. Data Security</h2>
              <p>We implement industry-standard security measures including encrypted data transmission (SSL/TLS), secure password hashing, and access controls to protect your personal information.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">5. Your Rights</h2>
              <ul className="list-disc pl-5 space-y-1">
                <li>Access and update your personal information through your profile settings.</li>
                <li>Request deletion of your account and associated data.</li>
                <li>Opt out of non-essential communications.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">6. Cookies</h2>
              <p>We use essential cookies to maintain your login session and preferences. We do not use third-party tracking cookies.</p>
            </section>

            <section>
              <h2 className="text-lg font-semibold text-gray-900 mb-2">7. Contact</h2>
              <p>For privacy-related questions or requests, contact us at <a href="mailto:info@topinfo.rw" className="text-primary-600 hover:underline">info@topinfo.rw</a>.</p>
            </section>
          </div>

          <div className="mt-8 text-center">
            <Link to="/" className="text-primary-600 hover:text-primary-700 text-sm font-medium">&larr; Back to Home</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPage;
